/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillgroupskills2Inputs */

const en_entity_skillgroupskills2 = /** @type {(inputs: Entity_Skillgroupskills2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Group Skills`)
};

const de_entity_skillgroupskills2 = /** @type {(inputs: Entity_Skillgroupskills2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills`)
};

/**
* | output |
* | --- |
* | "Skill Group Skills" |
*
* @param {Entity_Skillgroupskills2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillgroupskills2 = /** @type {((inputs?: Entity_Skillgroupskills2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillgroupskills2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillgroupskills2(inputs)
	return de_entity_skillgroupskills2(inputs)
});
export { entity_skillgroupskills2 as "entity_skillGroupSkills" }